import { cn } from '@buildbee/ui';

/**
 * The WRKRBZ mark, exactly as drawn on wrkrbz.com: a rounded hexagon outline holding "WB", with
 * the honey dot. The ink is `currentColor`, so it follows light and dark themes; the dot stays
 * honey (#F2C12E). `heavy` is the site's favicon weight (thicker strokes, bigger dot) for small
 * sizes. `public/favicon.svg` is the same drawing at the heavy weight.
 */
export const MARK_PATHS = {
  hexagon:
    'M91.00 43.07Q95.00 50.00 91.00 56.93L76.50 82.04Q72.50 88.97 64.50 88.97L35.50 88.97Q27.50 88.97 23.50 82.04L9.00 56.93Q5.00 50.00 9.00 43.07L23.50 17.96Q27.50 11.03 35.50 11.03L64.50 11.03Q72.50 11.03 76.50 17.96Z',
  w: 'M23.5 36L30 64L36.5 44.96L43 64L49.5 36',
  b: 'M56 36V64M56 36H65C70.5 36 73 39 73 43C73 47 70.5 50 65 50H56M56 50H66.5C72 50 75 53 75 57C75 61 72 64 66.5 64H56',
} as const;

export const HONEY = '#F2C12E';

const WEIGHTS = {
  regular: { hexagon: 3.2, letters: 5.4, dot: 6.5 },
  heavy: { hexagon: 6.5, letters: 8, dot: 9 },
} as const;

export function Logo({ className, heavy, label = 'BuildBee' }: { className?: string; heavy?: boolean; label?: string }) {
  const w = WEIGHTS[heavy ? 'heavy' : 'regular'];
  return (
    <svg viewBox="0 0 100 100" className={cn('size-8 text-foreground', className)} data-mark="wrkrbz" {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}>
      <path d={MARK_PATHS.hexagon} fill="none" stroke="currentColor" strokeWidth={w.hexagon} />
      <path d={MARK_PATHS.w} fill="none" stroke="currentColor" strokeWidth={w.letters} strokeLinecap="round" strokeLinejoin="round" />
      <path d={MARK_PATHS.b} fill="none" stroke="currentColor" strokeWidth={w.letters} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="72.5" cy="11" r={w.dot} fill={HONEY} />
    </svg>
  );
}

/** Mark + "BuildBee" wordmark text (auth pages, portal picker). */
export function Wordmark() {
  return (
    <span className="inline-flex items-center gap-2.5 font-display text-[19px] font-semibold tracking-[-0.01em]">
      <Logo className="size-8" label="" /> BuildBee
    </span>
  );
}
